/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}input[_ngcontent-%COMP%], input[_ngcontent-%COMP%]:active, input[_ngcontent-%COMP%]:focus{border:0;border-bottom:1px solid rgba(149,160,177,.35);font-size:18px;text-align:left;background:0 0;color:#b5becb;border-radius:unset;margin-left:10px;outline:0;caret-color:var(--mmi-secondary-btn)}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/core/achoo-material-input/achoo-material-input.component.scss.shim.ngstyle.js.pre-build-optimizer.js